import type { RestoreWizardConfig } from '../types'

export const PROJECT_WIZARD_CONFIG: RestoreWizardConfig = {
  kind: 'PROJECT_POLICY',
  kindLabel: 'Project Policy Restore',
  unitIds: { select: 'project-wz-1', repositories: 'project-wz-2', targets: 'project-wz-3', plan: 'project-wz-4', order: 'project-wz-5' },
  targetScopeForm: 'PROJECTS',
  singleRef: false,
}
